import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Container, Row } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { fieldOfficerReportApi } from 'api/endpoints/FieldOfficer';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

const FieldOfficerForm = ({ edit = false, view = false }) => {
  const tenant = getTenantFromToken();
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const navigate = useNavigate();
  const { id } = useParams();
  const fieldOfficerId = id;

  const [data, setData] = useState({});
  const [title, setTitle] = useState('');

  // Fetch form data based on mode (Create, Edit, View)
  const fetchFormData = async () => {
    try {
      let response;
      if (edit || view) {
        response = await fieldOfficerReportApi.getEditFieldOfficerForm(
          fieldOfficerId,
          edit,
          view
        );
      } else {
        response = await fieldOfficerReportApi.getFieldOfficerForm(false);
      }
      setTitle(response?.data?.results?.form?.title);
      setData(response?.data?.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    fetchFormData();
  }, [fieldOfficerId, edit, view]);

  // Handle form submission
  const handleFormSubmit = async formData => {
    try {
      let response;
      if (edit) {
        response = await fieldOfficerReportApi.submitEditFieldOfficer(
          fieldOfficerId,
          formData
        );
      } else {
        response = await fieldOfficerReportApi.submitFieldOfficer(formData);
      }

      formSubmissionToast(response, toast, 'Field Officer', edit);
      navigate(`/${tenant}/fieldOfficerReport`);
    } catch (error) {
      console.error('Submission Error:', error);
      formSubmissionToast(error, toast, 'Field Officer', edit);
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/fieldOfficerReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{title}</span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
                view={view}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
};

FieldOfficerForm.propTypes = {
  edit: PropTypes.bool,
  view: PropTypes.bool
};

export default FieldOfficerForm;
